interface KPICardProps {
  label: string
  value: number | string
  delta?: string
  deltaType?: 'up' | 'down' | 'neutral'
}

export function KPICard({ label, value, delta, deltaType = 'neutral' }: KPICardProps) {
  return (
    <div className="bg-bg-surface border border-border-subtle border-l-[3px] border-l-primary-red rounded-lg p-4 relative overflow-hidden">
      <div className="text-[24px] font-semibold text-text-primary leading-tight">
        {typeof value === 'number' ? value.toLocaleString() : value}
      </div>
      <div className="text-[10px] uppercase tracking-[0.5px] text-text-secondary font-medium mt-1">
        {label}
      </div>
      {delta && (
        <div
          className={`text-[10px] mt-2 ${
            deltaType === 'up'
              ? 'text-success'
              : deltaType === 'down'
                ? 'text-error'
                : 'text-text-tertiary'
          }`}
        >
          {delta}
        </div>
      )}
    </div>
  )
}
